module.exports = __webpack_public_path__ + "img/charity_pig.a7c168d8.svg";